import { Box, Typography } from '@mui/material';
import { AiFillAudio } from 'react-icons/ai';
import { IoIosAttach } from 'react-icons/io';
import useStyles from './index.styles';

import { ChatButton } from '../index.styles';

const CustomerChatTypeBox = ({
  onSend,
  message,
  setMessage,
}: {
  onSend: () => void;
  message: string;
  setMessage: (x: string) => void;
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.typeBoxWrapper}>
      <input
        type='text'
        placeholder='Type your message or select template to send'
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSend();
        }}
      />

      <Box className={classes.typeBoxIconCont}>
        <AiFillAudio />
        <IoIosAttach />
        <ChatButton onClick={onSend}>
          <Typography>SEND</Typography>
        </ChatButton>
      </Box>
    </Box>
  );
};
export default CustomerChatTypeBox;
